import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=e5cafcec&scoped=true&"
import script from "./StaticPage.vue?vue&type=script&lang=js&"
export * from "./StaticPage.vue?vue&type=script&lang=js&"
import style0 from "./StaticPage.vue?vue&type=style&index=0&id=e5cafcec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cafcec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/var/www/app/components/FormInput.vue').default,FormTextarea: require('/var/www/app/components/FormTextarea.vue').default,Btn: require('/var/www/app/components/Btn.vue').default,Page: require('/var/www/app/components/Page.vue').default})
